import { EventDocument } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/types';
import { useDownloadFileUsingFileStorageUrl } from '@dealstack/frontend/shared/modules/document/file/hooks/useDownloadFileUsingFileStorageUrl';

/** Downloads the file a history event recorded, which may since have been replaced. */
export const useDownloadHistoryDocument = (dealId: string) => {
	const { downloadFile } = useDownloadFileUsingFileStorageUrl();

	return ({ fileId, fileName }: EventDocument) => {
		if (!fileId) {
			return;
		}
		void downloadFile({ dealId, fileId, fileName });
	};
};
